import { useEffect, useRef } from 'react';

import type { DatadogSpan } from '../../utilities/dataDog';
import LoadingSpinner from './LoadingSpinner';
import Spacer from './styles/spacer';

type FallbackProps = {
  errorReportTimeout?: number;
  span: DatadogSpan;
};

const Fallback = ({ errorReportTimeout, span }: FallbackProps): React.ReactElement => {
  const timeoutReporterId = useRef(0);

  useEffect(() => {
    if (!errorReportTimeout) {
      return () => {};
    }

    timeoutReporterId.current = window.setTimeout(() => {
      span.addErrorEvent('Failure');
    }, errorReportTimeout);

    return () => window.clearTimeout(timeoutReporterId.current);
  }, [errorReportTimeout, span]);

  return (
    <Spacer>
      <LoadingSpinner />
    </Spacer>
  );
};

export default Fallback;
